import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

interface DramaCardProps {
  drama: Drama;
  variant?: "poster" | "row";
}

export default function DramaCard({ drama, variant = "poster" }: DramaCardProps) {
  if (variant === "row") {
    return (
      <Link
        to={`/detail/${drama.id}`}
        className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 md:p-4"
      >
        <span className="block h-36 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-44 md:w-32">
          <img
            src={drama.poster}
            alt={`${drama.title}海报`}
            title={`${drama.title} 剧集海报`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </span>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
              {drama.title}
            </h3>
            <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
              {drama.rating} 分
            </span>
          </div>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">
            {drama.year} · {drama.genre} · 全 {drama.episodes} 集 · 更新至{" "}
            {drama.updateTime}
          </p>
          <p className="mt-2 line-clamp-2 text-sm text-foreground-600 md:line-clamp-3">
            {drama.summary}
          </p>
          <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-3">
            {drama.tags.slice(0, 4).map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/detail/${drama.id}`} className="group block cursor-pointer">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title}海报`}
          title={`${drama.title} 剧集海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {drama.featured && (
          <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
            热播
          </span>
        )}
        <span className="absolute right-2 top-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          {drama.rating}
        </span>
      </div>
      <h3 className="mt-2 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
        {drama.title}
      </h3>
      <p className="mt-0.5 truncate text-xs text-foreground-500">{drama.genre}</p>
    </Link>
  );
}